import { PhotoCamera } from "@mui/icons-material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { ReactNode } from "react";

type ButtonFileProps = {
  loading?: boolean;
  label?: string;
  onChange: (file: File) => void;
  icon?: ReactNode;
  accept?: string[];
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
};

export function ButtonFile({
  onChange,
  label,
  icon,
  accept,
  error,
  helperText,
  disabled,
  loading,
}: ButtonFileProps) {
  return (
    <>
      <Button
        component="label"
        size="small"
        startIcon={icon || <PhotoCamera />}
        variant="outlined"
        color={error ? "error" : "primary"}
        disabled={disabled || loading}
      >
        {label ? `<${label}>` : loading ? "Subindo arquivo..." : "Upload"}
        <input
          hidden
          accept={accept ? accept.join(",") : "image/*"}
          type="file"
          onChange={({ target: { files } }) => onChange(files[0])}
        />
      </Button>

      {error && (
        <Typography paddingLeft={2} variant="body2" color="error">
          {helperText}
        </Typography>
      )}
    </>
  );
}
